import { Box, Grid, Paper, Tabs, Tab, useTheme } from "@mui/material";
import React, { useState, useEffect } from "react";
import { NavLink, Outlet, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const tabStyle = {
  textTransform: "capitalize",
  fontWeight: "bold",
  borderRadius: "10px",
};

const ReportsNav = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const [value, setValue] = useState("/reports");
  const navigate = useNavigate();
  const location = useLocation();

  const handleChange = (event, newValue) => {
    setValue(newValue);
    navigate(newValue);
  };

  useEffect(() => {
    const path = location.pathname;
    if (path.startsWith("/reports/doctor-activity")) setValue("/reports/doctor-activity");
    else if (path.startsWith("/reports/lab-overall")) setValue("/reports/lab-overall");
    else if (path.startsWith("/reports/reception-revenue")) setValue("/reports/reception-revenue");
    else if (path.startsWith("/reports/pharmacy")) setValue("/reports/pharmacy");
    else if (path.startsWith("/reports/radiology")) setValue("/reports/radiology");
    else if (path.startsWith("/reports/laboratory")) setValue("/reports/laboratory");
    else if (path.startsWith("/reports/surgery")) setValue("/reports/surgery");
    else setValue("/reports");
  }, [location.pathname]);

  return (
    <Grid container maxWidth="xl" sx={{ width: "100%" }}>
      <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
        <Paper sx={{ padding: "10px 0px", boxShadow: "0px 0px 0px" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={{
              ml: "5px",
              "& .MuiTabs-indicator": { display: "none" },
              "& .MuiTab-root": { minWidth: "120px" },
            }}
          >
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/reports" ? theme.palette.primary.main : "white",
                color: value === "/reports" ? "white" : "black",
              }}
              label={t("reports.dashboard")}
              value="/reports"
              component={NavLink}
              to="/reports"
            />
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/reports/doctor-activity"
                    ? theme.palette.primary.main
                    : "white",
                color: value === "/reports/doctor-activity" ? "white" : "black",
              }}
              label={t("reports.doctorActivityReport")}
              value="/reports/doctor-activity"
              component={NavLink}
              to="/reports/doctor-activity"
            />
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/reports/lab-overall"
                    ? theme.palette.primary.main
                    : "white",
                color: value === "/reports/lab-overall" ? "white" : "black",
              }}
              label={t("reports.labOverallReport")}
              value="/reports/lab-overall"
              component={NavLink}
              to="/reports/lab-overall"
            />
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/reports/reception-revenue"
                    ? theme.palette.primary.main
                    : "white",
                color: value === "/reports/reception-revenue" ? "white" : "black",
              }}
              label={t("reports.receptionRevenueReport")}
              value="/reports/reception-revenue"
              component={NavLink}
              to="/reports/reception-revenue"
            />
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/reports/pharmacy" ? theme.palette.primary.main : "white",
                color: value === "/reports/pharmacy" ? "white" : "black",
              }}
              label={t("reports.pharmacyReport")}
              value="/reports/pharmacy"
              component={NavLink}
              to="/reports/pharmacy"
            />
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/reports/radiology" ? theme.palette.primary.main : "white",
                color: value === "/reports/radiology" ? "white" : "black",
              }}
              label={t("reports.radiologyReport")}
              value="/reports/radiology"
              component={NavLink}
              to="/reports/radiology"
            />
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/reports/laboratory" ? theme.palette.primary.main : "white",
                color: value === "/reports/laboratory" ? "white" : "black",
              }}
              label={t("reports.laboratoryReport")}
              value="/reports/laboratory"
              component={NavLink}
              to="/reports/laboratory"
            />
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/reports/surgery" ? theme.palette.primary.main : "white",
                color: value === "/reports/surgery" ? "white" : "black",
              }}
              label={t("reports.surgeryReport")}
              value="/reports/surgery"
              component={NavLink}
              to="/reports/surgery"
            />
          </Tabs>
        </Paper>
      </Box>
      <Outlet />
    </Grid>
  );
};

export default ReportsNav;
